import { hashHistory } from 'react-router'
import fetchPortalData from "./fetchPortalData";
import doVerifyToken from "./doVerifyToken";
import { checkAuthentication } from "../../authentication/actions/authenticationActions"

export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_VERIFICATION_TOKEN_EXCHANGE_START = "FETCH_VERIFICATION_TOKEN_EXCHANGE_START";
export const FETCH_VERIFICATION_TOKEN_EXCHANGE_SUCCESS = "FETCH_VERIFICATION_TOKEN_EXCHANGE_SUCCESS";

export const fetchNotificationsSuccess = (payload) => ({
    type: FETCH_NOTIFICATIONS_SUCCESS,
    payload
});

const fetchVerificationTokenExchangeStart = (payload) => ({
    type: FETCH_VERIFICATION_TOKEN_EXCHANGE_START,
    payload
});

const fetchVerificationTokenExchangeSuccess = (payload) => ({
    type: FETCH_VERIFICATION_TOKEN_EXCHANGE_SUCCESS,
    payload
});

export function loadNotifications() {
    return (dispatch) => {
        fetchPortalData(portalData => {
            dispatch(fetchNotificationsSuccess(portalData));
        });
    };
}

export function verifyToken(verificationToken, historyProvider = () => hashHistory) {
    return (dispatch) => {
        dispatch(fetchVerificationTokenExchangeStart(verificationToken));

        doVerifyToken(verificationToken, {
                      success: data => {
                          dispatch(fetchVerificationTokenExchangeSuccess({ verified: true }));
                          dispatch(checkAuthentication());
                          historyProvider().push("/portal");
                      },
                      failure: (code, response) => {
                          dispatch(fetchVerificationTokenExchangeSuccess({ verified: false, error: { code: code, message: response } }));
                      }
        });
    }
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/portal/actions/portalActions.js
 **/